import { EnumStatusTransferencia } from "model/enums/enum-status-transferencia";
import { TransferenciaHistoricoModel } from "./transferencia-historico-model";

export class TransferenciaGetModel {
    constructor(
        public id: string = '',
        public contaBancariaId: string = '',
        public configContaBancariaId: string = '',
        public pessoaId: string = '', //PESSOA DA TRANSFERENCIA (OPCIONAL)
        public usoEmpresa: string = '', //CAMPO LIVRE PARA EMPRESA
        public codigoFornecedor: string = '', // CPF/CNPJ DO DESTINATÁRIO
        public nomeFornecedor: string = '', // RAZAO/NOME DO DESTINATARIO
        public numeroCompromissoBanco: string = '', //GERADO AUTOMATICAMENTE NA API
        public numeroCompromissoCliente: string = '',//GERADO AUTOMATICAMENTE NA API
        public tipoPagamento: string = '',
        public bancoDestino: string = '', //CODIGO DO BANCO DO DESTINATARIO
        public agenciaDestino: string = '',
        public digitoAgenciaDestino: string = '',
        public contaCorrenteDestino: string = '',
        public nomeAgenciaDestino: string = '',
        public dataPagamento: string = '',
        public valorPagamento: number = 0,
        public valorAutorizado: number = 0,
        public status: EnumStatusTransferencia = EnumStatusTransferencia.Pendente,
        public externalId: string = '',
        public externalCode: string = '',
        public numeroInscricao: string = '', //CPF CNPJ DO PAGADOR
        public bancoPagador: string = '', //CODIGO BANCO DO PAGADOR
        public numeroConta: string = '', //CONTA CORRENTE DO PAGADOR
        public codigoAgencia: string = '', //AGENCIA DO PAGADOR
        public razaoSocial: string = '',
        // public nomeEmpresa: string = '',
        // public nomeBanco: string = '',
        public historicos: TransferenciaHistoricoModel[] = []
    ) { }
}